import React from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './AppLoading.css';

const AppLoading: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation();

  return (
    <div className="app-loading-container">
      <Container className="d-flex flex-column align-items-center justify-content-center min-vh-100">
        <div>
          <div className="loading-content">
            <div className="loading-text">
              <h4 className="loading-message">{t('general.appLoading')}</h4>
              <div className="loading-dots">
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default AppLoading;
